export var UserRole = /*#__PURE__*/function (UserRole) {
  UserRole["STUDENT"] = "student";
  UserRole["STUDENT_MANAGER"] = "student_manager";
  UserRole["STUDENT_ADVISOR"] = "student_advisor";
  UserRole["AGENT"] = "agent";
  UserRole["AGENT_MANAGER"] = "agent_manager";
  UserRole["AGENT_REGIONAL_MANAGER"] = "agent_regional_manager";
  UserRole["AGENT_REGIONAL_MANAGER_SUPERVISOR"] = "agent_regional_manager_supervisor";
  UserRole["INTERNATIONAL_RECRUITMENT_OFFCIER"] = "international_recruitment_officer";
  UserRole["CONTENT_EDITOR"] = "content_editor";
  UserRole["SALES_PERSON"] = "sales_person";
  UserRole["ADMIN"] = "admin";
  UserRole["SYS_ADMIN"] = "sys_admin";
  UserRole["EXTERNAL_CONTRACTOR"] = "external_contractor";
  UserRole["IMMIGRATION_CONSULTANT"] = "immigration_consultant";
  UserRole["REGULATED_CANADIAN_IMMIGRATION_CONSULTANT"] = "regulated_canadian_immigration_consultant";
  UserRole["SCHOOL_ADMIN"] = "school_admin";
  return UserRole;
}({});
export var SalesTierName = /*#__PURE__*/function (SalesTierName) {
  SalesTierName["DORMANT"] = "dormant";
  SalesTierName["NEW"] = "new";
  SalesTierName["BRONZE"] = "bronze";
  SalesTierName["SILVER"] = "silver";
  SalesTierName["GOLD"] = "gold";
  SalesTierName["PLATINUM"] = "platinum";
  return SalesTierName;
}({});